import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { dashboardAPI } from '../services/api'
import { useAuth } from '../context/AuthContext'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage } from '../utils/helpers'

const Dashboard = () => {
  const { user } = useAuth()
  const { showError } = useNotification()
  const [loading, setLoading] = useState(true)
  const [stats, setStats] = useState({
    appointments_total: 0,
    appointments_pending: 0,
    contacts_total: 0,
    contacts_unread: 0,
    subscribers: 0,
    posts: 0,
    services: 0,
    categories: 0,
    gallery: 0,
    testimonials: 0,
  })
  const [recentAppointments, setRecentAppointments] = useState([])

  useEffect(() => {
    fetchDashboardData()
  }, [])

  const fetchDashboardData = async () => {
    try {
      const response = await dashboardAPI.getStats()
      setStats(response.data.stats)
      setRecentAppointments(response.data.recentAppointments || [])
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="admin-page">
        <div>Loading dashboard...</div>
      </div>
    )
  }

  return (
    <div className="admin-page">
      <div className="page-head">
        <div>
          <div className="eyebrow">Overview</div>
          <h2 className="admin-title">Dashboard</h2>
          <p className="admin-sub">
            Welcome back, {user?.username}. Here's what's happening at the salon today.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-3 col-sm-6">
          <div className="stat-card">
            <div className="stat-icon gold">
              <i className="fa fa-calendar-check-o"></i>
            </div>
            <div className="stat-num">{stats.appointments_total}</div>
            <div className="stat-label">Total Appointments</div>
            <div className="stat-sub">{stats.appointments_pending} pending</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="stat-card">
            <div className="stat-icon rose">
              <i className="fa fa-envelope"></i>
            </div>
            <div className="stat-num">{stats.contacts_total}</div>
            <div className="stat-label">Messages</div>
            <div className="stat-sub">{stats.contacts_unread} unread</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="stat-card">
            <div className="stat-icon dark">
              <i className="fa fa-paper-plane"></i>
            </div>
            <div className="stat-num">{stats.subscribers}</div>
            <div className="stat-label">Newsletter Subscribers</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="stat-card">
            <div className="stat-icon gold">
              <i className="fa fa-pencil"></i>
            </div>
            <div className="stat-num">{stats.posts}</div>
            <div className="stat-label">Blog Posts</div>
          </div>
        </div>
      </div>

      <div className="row mt-4 row-eq-height">
        <div className="col-md-4">
          <div className="mini-stat">
            <span>Services</span>
            <strong>{stats.services}</strong>
          </div>
          <div className="mini-stat">
            <span>Categories</span>
            <strong>{stats.categories || 0}</strong>
          </div>
          <div className="mini-stat">
            <span>Gallery images</span>
            <strong>{stats.gallery}</strong>
          </div>
          <div className="mini-stat">
            <span>Reviews</span>
            <strong>{stats.testimonials}</strong>
          </div>
        </div>
        <div className="col-md-8">
          <div className="panel">
            <div className="panel-head">Quick Actions</div>
            <Link to="/admin/services" className="btn btn-outline-gold btn-block mb-2">
              <i className="fa fa-scissors"></i> Add Service
            </Link>
            <Link to="/admin/blog/new" className="btn btn-outline-gold btn-block mb-2">
              <i className="fa fa-plus"></i> New Blog Post
            </Link>
            <Link to="/admin/gallery" className="btn btn-outline-gold btn-block">
              <i className="fa fa-image"></i> Add Gallery Image
            </Link>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <div className="panel">
            <div className="panel-head">Recent Appointments</div>
            {recentAppointments.length > 0 ? (
              <div className="table-responsive">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Service</th>
                      <th>Date / Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentAppointments.map((appointment) => (
                      <tr key={appointment.id}>
                        <td>{appointment.name}</td>
                        <td>{appointment.service || '—'}</td>
                        <td>
                          {appointment.appointment_date || '—'}{' '}
                          {appointment.appointment_time || ''}
                        </td>
                        <td>
                          <span className={`badge badge-${appointment.status}`}>
                            {appointment.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="muted">No appointments yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
